export default __webpack_public_path__ + "static/media/vi-project@2x.e6461c92.jpg";